import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    let { name, object, url, create } = this.fieldTarget.dataset;
    create = create == "true" ? true : false;

    $(this.fieldTarget).selectize({
      allowEmptyOption: false, 
      placeholder: create ? "Choose or create one" : "Choose one",
      create:
        create &&
        function (input, callback) {
          $.ajax({
            method: "POST",
            url: url,
            data: { [object]: { [name]: input } },
            success: function (response) {
              // call callback with the new item
              callback({ value: response.id, text: response.name });
            },
          });
        },
    });
  }
}
